import React, { Dispatch, SetStateAction } from 'react';

import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { prefixLegend, suffixLegend } from '../../../../scripts/name.legend.script';
import { expressions } from '../../../../libraries/regular.expressions.library';
import { legendIconInvalid, legendIconValid, legendIconValidInvalidRestart } from '../../../../utils/legend.data.util';
import { languageValue } from '../../../../libraries/language.library';

import AppLegend from '../../../../components/element/Legend';

export interface AppInventoryFormNameProps {
  component?: string,
  action: string,
  names: {value: {en: string, fr: string, it: string, de: string}, valid: {en: boolean, fr: boolean, it: boolean, de: boolean}},
  setNames: Dispatch<SetStateAction<{value: {en: string, fr: string, it: string, de: string}, valid: {en: boolean, fr: boolean, it: boolean, de: boolean}}>>
};

const AppInventoryFormName: React.FunctionComponent<AppInventoryFormNameProps> = ({component, action, names, setNames}) => {
  const {lang} = StateLanguage()

  const handleChangeNames = (item: string, event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    setNames(names => ({...names, value: {...names.value, [item]: event.target.value}}))
  }

  const validateNames = (index: number, item: string) => {
    if (expressions && names.value[item as keyof typeof names.value].length > 0) {
      if (expressions.name.test(names.value[item as keyof typeof names.value])) {
        setNames(names => ({...names, valid: {...names.valid, [item]: true}}))
        legendIconValid(`${prefixLegend(component)}input-language-name${suffixLegend(index)}`, `${prefixLegend(component)}legend-language-name-valid${suffixLegend(index)}`)
      } else {
        setNames(names => ({...names, valid: {...names.valid, [item]: false}}))
        legendIconInvalid(`${prefixLegend(component)}input-language-name${suffixLegend(index)}`, `${prefixLegend(component)}legend-language-name-valid${suffixLegend(index)}`)
      }
    } else {
      setNames(names => ({...names, valid: {...names.valid, [item]: true}}))
      legendIconValidInvalidRestart(`${prefixLegend(component)}input-language-name${suffixLegend(index)}`, `${prefixLegend(component)}legend-language-name-valid${suffixLegend(index)}`)
    }
  }

  return (
    <div className={`card card-flush ${component && "shadow-none"}`}>
      <div className="card-header">
        <div className="card-title">
          <h3>{lang.labels.nameInOtherLanguages}</h3>
        </div>
      </div>
      <div className="card-body pt-0">
        <label className="form-label">{lang.labels.enterInLanguageWant}</label>
        { Object.entries(names.value).map (( (item, index) => { return (
          <div key={index} className="my-2">
            <input id={`${prefixLegend(component)}input-language-name${suffixLegend(index)}`} className="form-control" type="text" autoComplete="off" name="language-name" placeholder={languageValue(lang, item[0].toUpperCase())} value={item[1]} onChange={(event) => handleChangeNames(item[0], event)} onKeyUp={() => validateNames(index, item[0])} onBlur={() => validateNames(index, item[0])} />
            <AppLegend component={component} attribute={{check: names.valid[item[0] as keyof typeof names.valid], name: "language-name", index: index, sub_index: null}} container={{valid: true, required: false, identical: false, exists: false}}></AppLegend>
          </div>
        )}))}
        <div className={`form-text text-justify mt-5 ${action === "update" && "d-none"}`}>{lang.labels.ifYouWishYouCanAssignNameInLanguagesNecessary}</div>
      </div>
    </div>
  )
};

export default AppInventoryFormName;
